import { Typography, Stack, useTheme } from '@mui/material';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { graphql, useFragment } from 'react-relay';

import type { PaymentLinkAdditionalInfo_charge$key } from '../paymentLinkActive/__generated__/PaymentLinkAdditionalInfo_charge.graphql.ts';

type PaymentLinkAdditionalInfoProps = {
  charge: PaymentLinkAdditionalInfo_charge$key;
};

const PaymentLinkAdditionalInfo = (
  props: PaymentLinkAdditionalInfoProps,
): ReactNode => {
  const { t } = useTranslation();
  const theme = useTheme();

  const charge = useFragment<PaymentLinkAdditionalInfo_charge$key>(
    graphql`
      fragment PaymentLinkAdditionalInfo_charge on Charge {
        additionalInfo {
          key
          value
        }
      }
    `,
    props.charge,
  );

  if (!charge) {
    return null;
  }

  if (!charge.additionalInfo || charge.additionalInfo.length <= 0) {
    return null;
  }

  return (
    <Stack sx={{ alignItems: 'center', gap: 0.5 }}>
      <Typography variant='h6' fontWeight='bold' textAlign='center'>
        {t('Additional information')}
      </Typography>
      <Stack sx={{ gap: 0 }}>
        {charge.additionalInfo?.map((item) => {
          return (
            <Stack key={item?.key}>
              <Typography variant='body1' fontWeight='bold' textAlign='center'>
                {item?.key}
              </Typography>
              <Typography
                textAlign='center'
                sx={{ color: theme.palette.text.secondary }}
              >
                {item?.value}
              </Typography>
            </Stack>
          );
        })}
      </Stack>
    </Stack>
  );
};

export default PaymentLinkAdditionalInfo;
